import { render, staticRenderFns } from "./wxpricereqapprove.vue?vue&type=template&id=0e06ab3f&scoped=true&"
import script from "./wxpricereqapprove.vue?vue&type=script&lang=js&"
export * from "./wxpricereqapprove.vue?vue&type=script&lang=js&"
import style0 from "./wxpricereqapprove.vue?vue&type=style&index=0&id=0e06ab3f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e06ab3f",
  null
  
)

export default component.exports